import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import SpecialInstructionsModal from '../../../../../modules/ordering/components/SpecialInstructionsModal';
var defaultProps = {
  specialInstructions: ''
};
function SpecialInstructionsTrigger(_ref) {
  var specialInstructions = _ref.specialInstructions,
    onSpecialInstructionsChange = _ref.onSpecialInstructionsChange;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  var _useState5 = useState(specialInstructions),
    _useState6 = _slicedToArray(_useState5, 2),
    instructions = _useState6[0],
    setInstructions = _useState6[1];
  function onSave(_x) {
    return _onSave.apply(this, arguments);
  }
  function _onSave() {
    _onSave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setLoading(true);
            _context.next = 4;
            return onSpecialInstructionsChange(e, {
              value: instructions
            });
          case 4:
            setOpen(false);
            _context.next = 9;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
          case 9:
            _context.prev = 9;
            setLoading(false);
            return _context.finish(9);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7, 9, 12]]);
    }));
    return _onSave.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    fluid: true,
    className: "special-instructions-trigger-button",
    onClick: function onClick() {
      return setOpen(true);
    }
  }, "Special Instructions (optional)", /*#__PURE__*/React.createElement(Icon, {
    className: "special-instructions-trigger-button-icon",
    name: "chevron right"
  })), /*#__PURE__*/React.createElement(SpecialInstructionsModal, {
    specialInstructions: instructions,
    onSpecialInstructionsChange: function onSpecialInstructionsChange(e, _ref2) {
      var value = _ref2.value;
      return setInstructions(value);
    },
    open: open,
    onSave: onSave,
    onClose: function onClose() {
      return setOpen(false);
    },
    loading: loading
  }));
}
SpecialInstructionsTrigger.defaultProps = defaultProps;
export default SpecialInstructionsTrigger;